

























import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import IconCheck from '@/components/IconCheck.vue';
@Component({
  components: {
    IconCheck,
  },
})
export default class CheckboxField extends Vue {
  @Model('change', { type: Boolean }) value!: boolean;
  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  private get events(): { [key: string]: () => void } | {} {
    return !this.readonly
      ? { click: () => this.$emit('change', !this.value) }
      : {};
  }
}
